import type { App } from "vue";
import { createI18n } from "vue-i18n";
import type { IntlDateTimeFormats } from "vue-i18n";
import { defaultLangCode, IETF } from "./shared";

// Only import the default language statically
import enMessages from "./common/en.json";

const datetimeFormats: IntlDateTimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    "full-time": {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    },
  },
  de: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
  },
  es: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
  },
  fr: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
  },
  ja: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
  },
};

export const i18n = createI18n({
  locale: defaultLangCode,
  fallbackLocale: defaultLangCode,
  messages: {
    en: enMessages, // Only include default language initially
  },
  datetimeFormats,
});

export const { d, n, t } = i18n.global;

export const localesPlugin = async (app: App, lang: IETF) => {
  // Load the requested language if it's not the default
  if (lang !== defaultLangCode) {
    const { loadLanguage } = await import("./vue-language-loader.ts");
    await loadLanguage(lang);
  } else {
    i18n.global.locale = lang;
  }

  app.use(i18n);
};
